import * as React from 'react';
import { RouteComponentProps, StaticContext } from 'react-router';
import { AppLayoutBlank, Button, AppError, Space } from '@mc/ui-v4';
import { mcLock } from '@mc/react-ui-icons';
import { useAuth } from '@mc/react-auth';

type Props = RouteComponentProps<{}, StaticContext, {}>;

export const AppNotAssignedPage: React.FC<Props> = ({ history }) => {
  const auth = useAuth();

  return (
    <AppLayoutBlank horizontalCenter verticalCenter>
      <AppError
        icon={mcLock}
        message={'Nemáte oprávnění na tuto aplikaci/pohled'}
        className={'m-4'}
      >
        <Space vertical>
          <Button
            className={'mt-2'}
            style={'primary'}
            onClick={() => {
              auth.logout();
              history.replace('/');
            }}
          >
            Odhlásit
          </Button>
          <Button
            className={'mt-2'}
            style={'link'}
            onClick={() => {
              history.replace('/');
            }}
          >
            Přejít na úvodní stránku
          </Button>
        </Space>
      </AppError>
    </AppLayoutBlank>
  );
};
